import { Box, Image } from "@chakra-ui/react";
import coin from "../images/coin.png";

/**
 * @description 金幣
 * @return {JSX.Element}
 */
const Coin = () => {
  return (
    <Box
      pointerEvents={"none"}
      position={"absolute"}
      top={"5rem"}
      left={"-1rem"}
      display={{ base: "none", lg: "block" }}
    >
      <Image src={coin} alt="coin" />
    </Box>
  );
};

export default Coin;
